export default __webpack_public_path__ + "static/media/icon3.da9ed9e0.png";